










































import { Component, Vue} from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
import { Message } from '../../CommonUtils/fixed/Message'; // メッセージ
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル

// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

@Component
export default class MailSentInfoCreate extends ApiAccessBase {
  // 共通パス
  private APP_PATH = Constants.UKETSUKE_URL + '/mailsentinfo';

  // 画面初期化
  private created() {
    this.screenTitle = 'メール送信情報追加';
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['mail_sentinfo']);
    const path = this.APP_PATH + '/init';
    // APIアクセス
    this.apiAccess(path, Constants.API_METHOD_GET, false, false);
  }

  //メール送信情報の登録処理を行う。
  private registMailSentInfo() {
    // form成形
    this.moldingSendForm(this.$refs.form);
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      const errorBag: any = this.getFormErrorData(this.$refs.form);
      for (const error of Object.keys(errorBag)) {
        if (errorBag[error]) {
          if (this.focusElement('input-' + error) ) {
            break;
          }
        }
      }
      return;
    }
    if (!confirm(Message.I0003)) {
          return;
    } else {
      //登録処理
      const path : string = this.APP_PATH + '/create';
      // APIアクセス
      this.apiAccess(path, Constants.API_METHOD_POST, false, false);
      // 先頭へジャンプ
      this.hrefElement('af-const', -50);
    }
  }

  /**
   * 前画面に戻る
   */
  private returnPrevious() {
    if (!confirm(Message.I0014)) {
          return;
    } else {
      router.push('accepterMainMenu');
    }
  }

}
